export class ModuleManager {
  constructor(syncClient) {
    this.syncClient = syncClient;
    this.syncClient._modules = [];
  }

  register(modules) {
    for (const Module of modules) {
      this.syncClient._modules.push(new Module(this.syncClient));
    }
  }

  onPacketReceived(packet) {
    for (const module of this.syncClient._modules) {
      module.onPacketReceived(packet);
    }
  }
}
